export default {
  get: function(){
    return {
      values: [],
      fetching: false,
      error: false,
      success: false,
    };
  },
};
